import { useLocation } from "react-router-dom";
import DesktopNav from "./headerDesktop.component";
import MobileNav from "./headerMobile.component";
import constants from "../constants/constants";
import { useUserParams } from "../hooks/useUserParams";

const Header = () => {
  const pathname = useLocation();
  const { getCurrentAgentName, getCurrentLogo } = useUserParams();
  const agentName = (getCurrentAgentName && getCurrentAgentName()) || constants.AGENT_NAME;
  const logo = (getCurrentLogo && getCurrentLogo()) || constants.LOGO;

  return (
    <header
      className="fixed top-0 left-0 w-full z-50 pointer-events-auto"
      style={{ background: "transparent" }}
    >
      {/* Desktop: Half-circle with logo and agent name */}
      <div className="hidden lg:flex flex-col items-center relative w-full">
        {/* Half-circle background */}
        <div
          style={{
            background: `linear-gradient(180deg, ${constants.RURAL_COLORS.background} 60%, transparent 100%)`,
            width: 100,
            height: 50,
            borderTopLeftRadius: 100,
            borderTopRightRadius: 100,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            border: `4px solid ${constants.RURAL_COLORS.primary}`,
            borderBottom: "none",
            position: "relative",
            top: 18,
            zIndex: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 4px 12px rgba(124,103,74,0.10)",
          }}
          className="mx-auto"
        >
          <img
            src={logo}
            alt="Logo"
            width={48}
            height={48}
            style={{
              position: "absolute",
              left: "50%",
              top: 16,
              transform: "translate(-50%, 0)",
              zIndex: 4,
            }}
          />
        </div>
        {/* Agent name below logo */}
        <div
          style={{
            marginTop: 14,
            marginBottom: 12,
            fontFamily: "serif",
            fontWeight: 700,
            fontSize: 28,
            color: constants.RURAL_COLORS.primary,
            letterSpacing: 2,
            textShadow: "0 2px 8px #fff, 0 1px 0 #b7a16a",
            zIndex: 4,
          }}
        >
          {agentName.toUpperCase()}
        </div>
      </div>
      {/* Desktop Nav Bar */}
      <div className="hidden lg:flex justify-center relative z-2 -mt-4">
        <div
          style={{
            background: constants.RURAL_COLORS.background,
            borderRadius: 16,
            boxShadow: "0 2px 8px rgba(124,103,74,0.10)",
            maxWidth: 900,
            width: "90%",
            margin: "0 auto",
            border: `1.5px solid ${constants.RURAL_COLORS.primary}`,
          }}
        >
          <DesktopNav pathname={pathname} />
        </div>
      </div>
      {/* Mobile Nav remains unchanged */}
      <div className="lg:hidden">
        <MobileNav pathname={pathname} agentLogo={logo} />
      </div>
    </header>
  );
};

export default Header;
